import type { LocationSearchResult } from "@components/BulkReviews/types"
import { callApi } from "./index"

export const locationSearch = (locationSearchUrl: string, searchTerm: string, limit: number): Promise<LocationSearchResult[]> => {
  return callApi(`${locationSearchUrl}/${searchTerm}`, { limitResult: limit })
}